import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, CardBody } from "reactstrap";
import DataTable from "react-data-table-component";
import PageContainer from "../Layout/PageContainer";
import { retrieveCareer } from "../../redux/actions/career";

//import common filter component
import FilterComponent from "../../helpers/FilterComponent";
import debounceFunction from "../../helpers/Debounce";
import moment from "moment";
import CustomLoaderComponent from "../../common/customLoader";

export default function ActivityList() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);

  const { career, totalRows } = useSelector(
    (state) => state.careerReducer
  );

  const param = {
    page: page,
    perPage: perPage,
  };

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(retrieveCareer(param));
    };
    fetchData();
  }, [dispatch, page, perPage]);


  const handlePageChange = (page) => {
    const updatedParam = { ...param, page };
    dispatch(retrieveCareer(updatedParam));
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    const updatedParam = { ...param, perPage: newPerPage, page };  // Spread and update both perPage and page in one line
    await dispatch(retrieveCareer(updatedParam));                    // Await dispatch if it returns a Promise (like a thunk action)
    setPerPage(newPerPage);
  };


  const columns = useMemo(
    () => [
      {
        name: "Name",
        selector: (row) => (row.name ? row.name : "--"),
        sortable: true,
        headerStyle: { textAlign: "center" },
        width: "180px",
      },
      {
        name: "Email",
        selector: (row) => (row.email ? row.email : "--"),
        sortable: true,
        headerStyle: { textAlign: "center" },
        width: "220px",
      },
      {
        name: "Phone",
        selector: (row) => (row.phone ? row.phone : "--"),
        sortable: false,
        headerStyle: { textAlign: "center" },
        width: "150px",
      },
      {
        name: "Description",
        selector: (row) => (row.description ? row.description : "--"),
        sortable: false,
        headerStyle: { textAlign: "center" },
      },
      {
        name: "Resume",
        cell: (row) =>
          row.filePath ? (
            <a
              href={`${process.env.REACT_APP_API_URL}documents/${row.filePath}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              View File
            </a>
          ) : (
            "--"
          ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "150px",
        headerStyle: { textAlign: "center" },
      },
      {
        name: "Date & Time",
        selector: (row) =>
          row.createdAt
            ? `${moment(row.createdAt).format("Do MMM, YYYY")} - ${moment(row.createdAt).format("hh:mm:ss A")}`
            : "--",
        sortable: true,
        width: "250px",
        headerStyle: { textAlign: "center" },
      }
    ],
    []
  );

  return (
    <PageContainer
      pageTitleIcon="pe-7s-id icon-gradient bg-plum-plate"
      pageHeading="Career Requests"
      pageSubTitle="User-submitted career requests and uploaded resumes"
    >
      {loading ? (
        <CustomLoaderComponent />
      ) : (
        <Row>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <DataTable
                  columns={columns}
                  data={career}
                  pagination
                  paginationPerPage={perPage}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </PageContainer>
  );
}
